export default __webpack_public_path__ + "static/media/purple-heavy-dollar-sign.47aa6e34.svg";